<template>
	<div>
		<div class="fine w">
			<div class="fine-title" v-text="param.title"></div>
			<div class="fine-list">
				<div class="fine-item" v-for="(item,index) in param.list[0].goods_list" :key="index">
					<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" v-if="index<7">
						<div class="fine-item-img">
							<img :src="param.mark_url" alt="" class="mark-icon" v-if="param.mark == 1 && param.mark_url">
							<img :src="item.pic_url" alt="">
						</div>
						<div class="fine-item-txt" v-text="item.name"></div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.fine {
		height: 264px;
		background-color: #fff;
		margin-top: 20px;
		padding: 0 20px;
		box-sizing: border-box;
		.fine-title {
			height: 60px;
			font-size: 18px;
			font-weight: 600;
			display: flex;
			align-items: center;
		}

		.fine-list {
			margin-top: 10px;
			display: flex;

			.fine-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;

				a {
					display: block;
				}

				+.fine-item {
					margin-left: 33px;
				}

				.fine-item-img {
					position: relative;
					height: 136px;
					width: 136px;
					.mark-icon{
						position: absolute;
						top: 0;
						left: 0;
						width: 36px;
						height: 36px;
					}
				}

				.fine-item-txt {
					margin-top: 16px;
					width: 133px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					text-align: center;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;
				}

				&:hover {
					opacity: 0.8;
				}

				&:hover .fine-item-txt {
					color: #FF0E25;
				}
			}
		}
	}
</style>
